import React, { useState } from "react";
import image1 from "../../images-optimized/page1.webp";
import image2 from "../../images-optimized/page2.webp";
import image3 from "../../images-optimized/page3.webp";
import image4 from "../../images-optimized/page4.webp";
import image5 from "../../images-optimized/page5.webp";
import image6 from "../../images-optimized/page6.webp";
import image7 from "../../images-optimized/page7.webp";
import image8 from "../../images-optimized/page8.webp";
import image9 from "../../images-optimized/page9.webp";
import image10 from "../../images-optimized/page10.webp";
import image11 from "../../images-optimized/page11.webp";
import image12 from "../../images-optimized/page12.webp";
import image13 from "../../images-optimized/page13.webp";
import image14 from "../../images-optimized/page14.webp";
import image15 from "../../images-optimized/page15.webp";
import image16 from "../../images-optimized/page16.webp";
import image17 from "../../images-optimized/page17.webp";

const images = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
];

function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div style={styles.carousel}>
      <button style={styles.buttonLeft} onClick={prevSlide}>
        ‹
      </button>

      <img src={images[currentIndex]} alt="carousel" style={styles.image} />

      <button style={styles.buttonRight} onClick={nextSlide}>
        ›
      </button>
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  carousel: {
    textAlign: "center",
    position: "relative",
    width: "80%",
    margin: "auto",
    overflow: "hidden",
    borderRadius: "10px",
  },
  image: {
    width: "75%",
    objectFit: "cover",
    borderRadius: "10px",
    display: "unset",
    backgroundColor: "rgb(252 245 231)",
  },
  buttonLeft: {
    padding: "revert",
    position: "absolute",
    top: "50%",
    left: "15px",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.5)",
    color: "white",
    border: "none",
    fontSize: "2rem",
    borderRadius: "50%",
    cursor: "pointer",
  },
  buttonRight: {
    padding: "revert",
    position: "absolute",
    top: "50%",
    right: "15px",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.5)",
    color: "white",
    border: "none",
    fontSize: "2rem",
    borderRadius: "50%",
    cursor: "pointer",
  },
};

export default ImageCarousel;
